import { render, staticRenderFns } from "./FlagshipProfilingSowosWealth.vue?vue&type=template&id=86c51522&scoped=true&"
import script from "./FlagshipProfilingSowosWealth.vue?vue&type=script&lang=ts&"
export * from "./FlagshipProfilingSowosWealth.vue?vue&type=script&lang=ts&"
import style0 from "./FlagshipProfilingSowosWealth.vue?vue&type=style&index=0&id=86c51522&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86c51522",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VContainer,VDialog,VIcon,VImg,VRow})
